import React from 'react';
import css from './SectionHeader.module.css';

/**
 * SectionHeader
 * Renders the labeled header row used above every card section.
 *
 * Props:
 *   label       {string}      – primary section label (lowercase, accent-soft)
 *   progress    {string}      – optional progress annotation, e.g. "2/5 done"
 *   action      {string}      – optional right-side link text
 *   onAction    {function}    – callback when action is clicked
 *   actionEl    {ReactNode}   – alternative: pass a pre-built right-side element
 *                               (takes precedence over action/onAction)
 */
export default function SectionHeader({ label, progress, action, onAction, actionEl }) {
  return (
    <div className={css.sectionHdr}>
      <div className={css.sectionLabel}>
        {label}
        {progress && <span className={css.sectionProgress}> · {progress}</span>}
      </div>
      {actionEl
        ? actionEl
        : action && (
            <button className={css.sectionLink} onClick={onAction}>
              {action}
            </button>
          )}
    </div>
  );
}
